import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
	SuiModal,
	ComponentModalConfig,
	ModalSize,
} from "@richardlt/ng2-semantic-ui";
import { AppFilter } from "src/modules/shared/";

interface IFileUploadModalContext {
	title: string;
	data: any;
}

@Component({
	selector: "app-file-upload-modal",
	templateUrl: "./file-upload-modal.component.html",
	styleUrls: ["./file-upload-modal.component.scss"],
})
export class FileUploadModalComponent implements OnInit {
	pending: boolean;
	success: any;
	error: any;
	filter: AppFilter = new AppFilter();

  data;

  fileObj: any;
  fileName: string;

  onFileAttached = new EventEmitter();
  sizeLimit = 5000000;
  allowedFormats: string[] = [];
  isDisabled: boolean = false;
  hasDocumentTitle: boolean = false;
  documentTitle: string = "Document Title";
  defaultTitle: string = "Document Title";
  documentTitles: string[] = [];
  selectedFiles: any[] = [];

  constructor(public modal: SuiModal<IFileUploadModalContext, void, void>) { }

  ngOnInit(): void {
  }

  filesAttached(event: any) {
    for (let file of event.target.files) {
      this.selectedFiles.push(file);
      this.documentTitles.push(this.documentTitle)
    }
    this.onFileAttached.emit(event);
  }

  removeFile(i: number) {
    this.selectedFiles.splice(i, 1);
    if (this.hasDocumentTitle) {
      this.documentTitles.splice(i, 1);
    }
  }

  viewFile(file: File) {
    const reader = new FileReader();
    const extension: string = file.name.split('.').pop() || "";

    reader.onload = (e: any) => {
      const fileContent = e.target.result;

      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') {
        const newTab = window.open();
        newTab?.document.write('<html><body><img src="' + fileContent + '" /></body></html>');
      } else if (extension === 'pdf') {
        const newTab = window.open();
        newTab?.document.write('<html><body><embed width="100%" height="100%" src="' + fileContent + '" /></body></html>');
      } else if (['docx', 'doc', 'xlsx'].includes(extension)) {
        const newTab = window.open();
        newTab?.document.write('<html><body><iframe width="100%" height="100%" src="' + fileContent + '"></iframe></body></html>');
      } else if (extension === 'txt') {
        const newTab = window.open();
        newTab?.document.write('<html><body><pre>' + fileContent + '</pre></body></html>');
      } else {
        const newTab = window.open();
        newTab?.document.write('Unknown file format');
      }
    };

    if (extension === 'txt') {
      reader.readAsText(file)
    } else {
      reader.readAsDataURL(file);
    }
  }

  getAllowedFormats() {
    if (!this.allowedFormats?.length) {
      return "pdf";
    }
    return this.allowedFormats.join(",");
  }

  uploadDoc($event) {
    this.fileObj = $event[0];
    this.fileName = this.fileObj["name"];
  }
}

export class FileUploadModal extends ComponentModalConfig<
	IFileUploadModalContext,
	void,
	void
> {
	constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
		super(FileUploadModalComponent, { title: title, data: data });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = "slide left";
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
